import { readResponseOrGate } from './apiGate';

const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/**
 * Invites a user into the caller's organization. `firstName`/`lastName` are the exact
 * name the admin entered; they're stored on the invite and applied verbatim to the
 * account created on accept (`lastName` optional).
 * Returns { gate: true, body } on HTTP 402, otherwise { gate: false, ok, status, text }.
 */
export async function inviteOrgMember({ inviterUserId, orgId, email, firstName, lastName, role }) {
  const response = await fetch(`${apiUrl}/api/org/members/invite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({
      inviterUserId,
      orgId,
      email: email.trim(),
      ...(firstName && firstName.trim() ? { firstName: firstName.trim() } : {}),
      ...(lastName && lastName.trim() ? { lastName: lastName.trim() } : {}),
      ...(role ? { role: String(role).toLowerCase() } : {}),
    }),
  });

  const gateResult = await readResponseOrGate(response);
  if (gateResult.gate) {
    return gateResult;
  }

  const text = await gateResult.response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    data = null; // error bodies are plain strings
  }
  return {
    gate: false,
    ok: gateResult.response.ok,
    status: gateResult.response.status,
    text,
    data,
  };
}
